import { useNavigate } from "react-router-dom";
import { useOrderDraft } from "../../context/OrderDraftContext";
import { useApi } from "../../hooks/useApi";
import { saveService } from "../../services/save";
import { SaveResponse } from "../../types/save.types";
import { futureDateError } from "../../lib/validators";
import { PATHS } from "../../app/paths";

// Hospital, data desejada e tipo de cirurgia do rascunho; salva e segue para o PDF.
export const useSurgicalIndication = () => {
  const { surgery, setSurgery, hospital, setHospital, desiredDate, setDesiredDate, timestamp, surgerie } = useOrderDraft();
  const navigate = useNavigate();
  const { request, loading, apiFetch } = useApi<SaveResponse>();
  // A data já salva no pedido vale mesmo no passado; só uma data nova precisa ser futura.
  const dateError = desiredDate === surgerie?.dataDesejada ? null : futureDateError(desiredDate);
  const canSubmit = Boolean(surgery && hospital && desiredDate && !dateError);

  const submit = async () => {
    if (!canSubmit || loading) return;
    const result = await request(() =>
      saveService.post(apiFetch, { timestamp, hospital, dataDesejada: desiredDate, tipoCirurgia: surgery })
    );
    if (result?.status === "success") navigate(PATHS.orderReview);
  };

  return { surgery, setSurgery, hospital, setHospital, desiredDate, setDesiredDate, dateError, canSubmit, submit, loading };
};
